import { Middleware } from "redux";
import {
  END_PULSE_CONTENT,
  FINISH_PULSE_CONTENT,
  EndPulseContentAction,
  FinishPulseContentAction,
  endPulseContent,
  removePlaybackDuration,
} from "./actions";

/**
 * Middleware that automatically dispatches removePlaybackDuration
 * after finishPulseContent to ensure proper timing
 */
export const pulseMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (action.type === FINISH_PULSE_CONTENT) {
    // Use setTimeout to ensure the finished state is processed by selectors
    const finishAction = action as FinishPulseContentAction;
    const pulseItemKey = finishAction.payload.pulseItemKey;
    setTimeout(() => {
      store.dispatch(endPulseContent(pulseItemKey));
    }, 0);
  }
  if (action.type === END_PULSE_CONTENT) {
    const endAction = action as EndPulseContentAction;
    const pulseItemKey = endAction.payload.pulseItemKey;
    setTimeout(() => {
      store.dispatch(removePlaybackDuration(pulseItemKey));
    }, 0);
  }

  return result;
};
